import { createServerFn } from "@tanstack/react-start";

import { authMiddleware, mondayBoards } from "@onesolution/middlewares";

import queryClient from "@onesolution/components/ProvidersWrapper/queryClient";
import { USER_ROLES } from "@onesolution/constants";
import { rolesCheck } from "@onesolution/middlewares/rolesCheck";
import { formatUserColumnsForMutation } from "@onesolution/monday/format";
import { mondayClient } from "@onesolution/monday/monday";
import { wrapWithUseMutation } from "..";
import { UserMutationParams } from "../user";

const handler = createServerFn({ method: "POST" })
	.middleware([authMiddleware, mondayBoards, rolesCheck([USER_ROLES.Admin])])
	.validator(UserMutationParams)
	.handler(async ({ context, data }) => {
		const columnValues = formatUserColumnsForMutation(data);

		if (!data.id) throw "id is required";

		const updatedUser = await mondayClient.mutation.updateItem(
			{
				itemId: data.id!,
				boardId: context.boards.users,
				columnValues,
			},
			context,
		);

		if (!updatedUser) {
			throw { error: "Error while updating user." };
		}

		return updatedUser;
	});

export const updateUserOnServer = wrapWithUseMutation(handler, {
	onSuccess: () => {
		queryClient.invalidateQueries({ queryKey: ["users"] });
	},
});
